<template>
  <div class="profile-tab-wrap">
    <a-tabs
      v-model="activeKey"
      @tabClick="handleTabClick"
      ref="tabs"
      :class="[{ 'hide-third-level': $route.params.id }]"
    >
      <a-tab-pane key="summary" tab="Profile Summary">
        <ProfileSummary :id="id" />
      </a-tab-pane>
      <a-tab-pane key="basic_information" tab="Basic Information">
        <div class="create-profile-wrapper">
          <BasicInfo :id="id" />
        </div>
      </a-tab-pane>
      <a-tab-pane key="pictures" tab="Pictures">
        <div class="create-profile-wrapper padding-10px-imp">
          <Pictures />
        </div>
      </a-tab-pane>
      <a-tab-pane key="player_details" tab="Player Details">
        <div class="create-profile-wrapper">
          <PlayerDetail :id="id" />
        </div>
      </a-tab-pane>
      <a-tab-pane key="academic_information" tab="Academic Information">
        <div class="create-profile-wrapper">
          <AcademicInfo :id="id" />
        </div>
      </a-tab-pane>
      <a-tab-pane
        key="videos"
        tab="Videos"
        v-if="athlete.profileType === 'Paid' || athlete.profileType === 'Free'"
      >
        <div class="create-profile-wrapper">
          <VideoListing v-if="routeMatch('listing')" />
          <VideoInfo :id="id" v-else />
        </div>
      </a-tab-pane>
      <a-tab-pane
        key="teams_played"
        tab="Teams Played"
        v-if="athlete.profileType === 'Paid' || athlete.profileType === 'Free'"
      >
        <div class="create-profile-wrapper">
          <TeamsInfo :id="id" />
        </div>
      </a-tab-pane>
      <a-tab-pane
        key="events"
        tab="Events"
        v-if="athlete.profileType === 'Paid' || athlete.profileType === 'Free'"
      >
        <div class="event-wrapper">
          <Events :id="id" />
        </div>
      </a-tab-pane>
      <a-tab-pane
        key="profile_blocking"
        tab="Profile Blocking"
        v-if="athlete.profileType === 'Paid'"
      >
        <div class="event-wrapper">
          <ProfileBlocking :id="id" />
        </div>
      </a-tab-pane>
      <a-tab-pane
        key="public_view"
        tab="Public View"
        v-if="athlete.profileType === 'Basic'"
      >
        <PublicView :id="id" :public="true" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import ProfileSummary from "./ProfileSummary/ProfileSummary";
import BasicInfo from "./BasicInfo/BasicInfo";
import PlayerDetail from "./PlayerDetail/PlayerDetail";
import AcademicInfo from "./AcademicInfo/AcademicInfo";
import VideoInfo from "./VideoInfo/VideoInfo";
import VideoListing from "./VideoInfo/videos-listing";
import TeamsInfo from "./TeamsInfo/TeamsInfo";
import Events from "@/views/athlete-events-list";
import Pictures from "./Pictures/pictures";
import PublicView from "./public-view";
import ProfileBlocking from "./profile-blocking";
import { mapGetters, mapActions } from "vuex";
import { Base } from "@/models";

const STORE_KEY = "playerStore";
const ATHLETE_STORE_KEY = "athleteStore";
const CHAT_STORE_KEY = "chatStore";

export default {
  components: {
    ProfileSummary,
    BasicInfo,
    PlayerDetail,
    AcademicInfo,
    VideoInfo,
    TeamsInfo,
    Events,
    VideoListing,
    Pictures,
    PublicView,
    ProfileBlocking
  },
  mounted() {
    window.scrollTo({ top: 0});
    this.$store.dispatch(`${ATHLETE_STORE_KEY}/getAthlete`, {
      id: this.id,
      profileId: this.$route.params.profileId
    });
  },
  data() {
    return {
      activeKey: "summary"
    };
  },
  computed: {
    id() {
      return (
        this.$route.params.id ||
        this.$route.params.profileId ||
        localStorage["profile-id"]
      );
    },
    profileType() {
      return this.athlete.profileType;
    },
    profileId() {
      return Base.profileId();
    },
    ...mapGetters({
      ProfileData: `${STORE_KEY}/getViewProfileData`,
      athlete: `${ATHLETE_STORE_KEY}/athlete`
    }),
    routeName() {
      const routes = this.$route.path.split("/");
      return routes[routes.length - 1];
    }
  },
  methods: {
    handleTabClick(e) {
      this.$router.push({
        path: `/${this.$route.params.profileId}/athelete/${e}`,
        query: { key: "profile-list-player" }
      });
    },
    ...mapActions({
      setProfileData: `${STORE_KEY}/setViewProfileData`
    }),
    routeMatch(params) {
      return this.$route.path.match(params) ? true : false;
    }
  },
  watch: {
    routeName: {
      immediate: true,
      handler: function(newVal, _) {
        this.activeKey = newVal;
      }
    },
    profileType: function(newVal) {
      if (this.$route.params.id && newVal === "Basic") {
        this.$router.push(
          `/${this.$route.params.profileId}/athlete/${this.$route.params.id}/public_view`
        );
      }
    }
  }
};
</script>
<style lang="scss">
.hide-third-level {
  .ant-tabs-nav-container {
    display: none;
  }
  .show-tabs {
    .ant-tabs-nav-container {
      display: block !important;
    }
  }
}
</style>
